export default {
  CLOUD_BASE_API: 'https://cloud.viewgres.com:9443/api',// 旧版https://cloud.viewgres.com:9443/api
  CLOUD_BASE_TEST_API: 'https://cloud.viewgres.com:19443/api',// 间歇使用 旧版https://cloud.viewgres.com:19443/api 
  VGC_BASE_V4_API: 'https://i.viewgres.com:4321/vgc/api/v4',
  VGC_BASE_TEST_V4_API: 'https://i.viewgres.com:4321/vgc/beta/api/v4',
  SAP_BASE_V2_API: 'https://i.viewgres.com:4321/sap/api/v2',
  SAP_BASE_TEST_V2_API: 'https://i.viewgres.com:4321/sap/beta/api/v2',
  BASE_API_V1: 'https://api.viewgres.com',
  VIEWGLASS_API_V1: ' https://viewglass.viewgres.com:9797/api'
}